import React, { Component } from "react";
import cx from "classnames";
import { get } from "../../utils/apiHandler.js";
import tracking from "../../utils/tracking";
import _ from "underscore";
import moment from "moment";

moment.locale("fr");

export default class Termin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: undefined,
      time: undefined,
      timeslots: [],
      jsonDates: {},
    };

    this.onChangeDate = this.onChangeDate.bind(this);
    this.onChangeHour = this.onChangeHour.bind(this);
    this.submitTime = this.submitTime.bind(this);
  }

  componentWillMount() {
    get("/appointments/drweyrich").then((res) => {
      if (res.success) {
        this.setState({ jsonDates: res });
      }
    });
  }

  onChangeDate(e) {
    e.preventDefault();
    tracking.event("termin", "changeDate");
    this.setState({
      date: e.target.value,
      timeslots: this.state.jsonDates.hours[e.target.value] || [],
      time: undefined,
    });
  }
  submitTime(e) {
    e.preventDefault();
    tracking.event("termin", "submit", "success");
    this.props.onNext();
  }
  onChangeHour(e) {
    if (e.target.value === "-1") {
      this.setState({ timeslots: [], time: undefined, date: undefined });
      tracking.event("termin", "changeTime", "-1");
    } else {
      this.setState({ time: e.target.value });
      this.props.reservation({ date: this.state.date, time: e.target.value });
      tracking.event("termin", "changeTime", "nextStep");
      this.props.onNext();
    }
  }

  render() {
    let datesOptions = [];
    if (!_.isEmpty(this.state.jsonDates)) {
      datesOptions = this.state.jsonDates.dates.map((val, i) => {
        let date = moment(val, "DD-MM-YYYY").format("dddd, Do MMMM YYYY");
        return (
          <option key={i} value={val}>
            {date}
          </option>
        );
      });
    }

    let hoursOptions = this.state.timeslots.map((val, i) => {
      return (
        <option key={i} value={val}>
          {val}
        </option>
      );
    });

    let classes = cx("termin", "content", { hidden: !this.props.active });

    return (
      <div>
        <section className={classes}>
          <div className="form-group">
            <label>
              Sélectionnez votre date d'arrivée et laissez vous guider.
            </label>
            <select
              className="form-control"
              onChange={this.onChangeDate}
              value={this.state.date || "-1"}
            >
              <option value="-1">Sélectionnez votre date..</option>
              {datesOptions}
            </select>
          </div>
          {this.state.timeslots.length !== 0 && (
            <div className="form-group">
              <label>Choisissez l'heure qui vous convient le plus.</label>
              <select
                className="form-control"
                onChange={this.onChangeHour}
                value={this.state.time || "-1"}
              >
                <option value="-1">Sélectionnez l'heure..</option>
                {hoursOptions}
              </select>
            </div>
          )}
          {this.state.time && this.state.date && (
            <button
              className="btn btn-default pull-right"
              onClick={this.submitTime}
            >
              Suivant
            </button>
          )}
          <div className="clearfix"></div>
        </section>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/module/termin/index.js